const messages = {
    accountBox: {
        title: "Töölaud",
        description: "Jälgige kiiresti oma kampaaniaid ja punkte.",
        button: "AVA TÖÖLAUD",
    },
};

export default {
    messages,
};
